<template>
  <div>
    <body>
      <OnsaleHomeHeader/>
      <router-view />
      <div class=""></div>
      <OnsaleHomeFooter/>

    </body>
  </div>
</template>

<script>
  import OnsaleHomeHeader from '@/components/onsaleHome/OnsaleHomeHeader'
  import OnsaleHomeFooter from '@/components/onsaleHome/OnsaleHomeFooter'

  export default {
    name: 'OnsaleHome',
    data() {
      return {}
    },

    components: {
      OnsaleHomeHeader,
      OnsaleHomeFooter,
    },

    mounted() {
  
    },

    created() {

    },
    computed: {


    },

    methods: {


    }

  }
</script>

<style>

</style>
